<template>
  <transition name="dwp--fade">
    <i-frame id="dwp--wrapper" v-if="open">
      <BetaMessage />
    </i-frame>
  </transition>
</template>

<script>
import store from "@/store";
import Modal from "@/components/ui/Modal.vue";
import Logo from "@/components/illustrations/Logo.vue";
import { sync, call } from "vuex-pathify";

export default {
  store,
  components: {
    Modal,
    Logo,
  },
  computed: {
    open: sync("ui/open"),
  },
  components: {
    BetaMessage: () => import("@/components/BetaMessage.vue"),
    iFrame: () => import("@/components/ui/iFrame.vue"),
  },
};
</script>